// src/translations/messages.js
const messages = {
    en: {
      translation: {
        'nav.login': 'Log in',
        'nav.signup': 'Sign up for free',
        'nav.logout': 'Log Out',
        'nav.search': 'Search',
        'nav.services': 'Services',
        'nav.products': 'Products',
        'nav.preProduction': 'Pre-Production',
        'nav.scriptAnalysis': 'Script Analysis',
        'nav.budgeting': 'Budgeting',
        'nav.castingAssistant': 'Casting Assistant',
        'nav.location': 'Location',
        // Add all other keys from Nav.jsx
      },
    },
    es: {
      translation: {
        'nav.login': 'Iniciar sesión',
        'nav.signup': 'Regístrate gratis',
        'nav.logout': 'Cerrar sesión',
        'nav.search': 'Buscar',
        'nav.services': 'Servicios',
        'nav.products': 'Productos',
        'nav.preProduction': 'Preproducción',
        'nav.scriptAnalysis': 'Análisis de guion',
        'nav.budgeting': 'Presupuesto',
        'nav.castingAssistant': 'Asistente de casting',
        'nav.location': 'Ubicación',
        // Add all other keys
      },
    },
    fr: {
      translation: {
        'nav.login': 'Se connecter',
        'nav.signup': 'Inscrivez-vous gratuitement',
        'nav.logout': 'Déconnexion',
        'nav.search': 'Rechercher',
        'nav.services': 'Services',
        'nav.products': 'Produits',
        'nav.preProduction': 'Pré-production',
        'nav.scriptAnalysis': 'Analyse de scénario',
        'nav.budgeting': 'Budgétisation',
        'nav.castingAssistant': 'Assistant de casting',
        'nav.location': 'Emplacement',
        // Add all other keys
      },
    },
    // Add de, zh, ru, ja, hi, ta, bn with their respective translations
    };
  
  export default messages;
